/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';

//TODO move these styles to where appropriate
const customStyles = {
    content: {
        background: 'rgb(255, 255, 255)',
        borderRadius: '8px',
        bottom: 'none',
        display: 'block',
        height: 'auto',
        margin: '70px auto',
        outline: 'none',
        padding: '20px',
        width: '600px',
        border: '1px solid #252525',
        boxShadow: '0 5px 22px 4px rgba(0, 0, 0, 0.03), 0 7px 8px -4px rgba(0, 0, 0, 0.05)',
        overflow: 'hidden !important'
    },
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(20, 20, 20, 0.75)',
        overflow: 'auto',
        zIndex: 2000
    }
};

export default class CustomModal extends React.Component {
    static get propTypes() {
        return {
            children: PropTypes.node.isRequired,
            isOpen: PropTypes.bool.isRequired,
            name: PropTypes.string,
            onAfterOpen: PropTypes.func,
            onClose: PropTypes.func
        };
    }

    render() {
        return <div>
            <Modal
                ariaHideApp={false}
                isOpen={this.props.isOpen}
                onRequestClose={this.props.onClose}
                style={customStyles}
                contentLabel={this.props.name}
                onAfterOpen={this.props.onAfterOpen}>
                {this.props.children}
            </Modal>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/shareModal/CustomModal.js